import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
 
const CONTRACT_ADDRESS = "0x85dFA4a1ac85d3C2E76044239c13192040206Ef1";
const ABI = [
  "function makePrediction(bool isYes) public payable",
  "function resolveMarket(bool winner) public",
  "function claimWinnings() public",
  "function totalYes() public view returns (uint256)",
  "function totalNo() public view returns (uint256)",
  "function isResolved() public view returns (bool)",
  "function result() public view returns (bool)",
  "function yesBets(address) public view returns (uint256)",
  "function noBets(address) public view returns (uint256)",
  "event PredictionMade(address user, bool isYes, uint256 amount)"
];

export default function PredictionArena() {
  const [account, setAccount] = useState(null);
  const [balance, setBalance] = useState("0");
  const [provider, setProvider] = useState(null);
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(false);

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        const contractInstance = new ethers.Contract(CONTRACT_ADDRESS, ABI, signer);

        setAccount(accounts[0]);
        setProvider(provider);
        setContract(contractInstance);

        const bal = await provider.getBalance(accounts[0]);
        setBalance(ethers.formatEther(bal));
      } catch (error) {
        alert("Failed to connect wallet");
      }
    } else {
      alert("Please install MetaMask!");
    }
  };

  const makePrediction = async (isYes) => {
    if (!contract) return alert("Connect wallet first");
    setLoading(true);
    try {
      const tx = await contract.makePrediction(isYes, { value: ethers.parseEther("0.001") });
      await tx.wait();
      alert("✅ Prediction Made Successfully on Testnet!");
    } catch (error) {
      alert("Error: " + error.message);
    }
    setLoading(false);
  };

  const claimWinnings = async () => {
    if (!contract) return alert("Connect wallet first");
    setLoading(true);
    try {
      const tx = await contract.claimWinnings();
      await tx.wait();
      alert("✅ Winnings Claimed!");
    } catch (error) {
      alert("Error: " + error.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0a0a0a', color: '#fff', fontFamily: 'system-ui' }}>
      <header style={{ background: '#111', padding: '20px', borderBottom: '1px solid #333' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span style={{ fontSize: '32px' }}>🎲</span>
            <h1 style={{ fontSize: '28px', fontWeight: 'bold' }}>Prediction Arena</h1>
            <span style={{ background: '#10b981', color: '#000', padding: '6px 14px', borderRadius: '9999px', fontSize: '14px' }}>LIVE TESTNET</span>
          </div>
          <a href="/" style={{ color: '#10b981' }}>← Back to Terminal</a>
        </div>
      </header>

      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '40px 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h2 style={{ fontSize: '48px', marginBottom: '10px' }}>Real Testnet Prediction Arena</h2>
          <p style={{ fontSize: '24px', color: '#10b981' }}>Polygon Amoy • Fake Money Practice</p>
        </div>

        {!account ? (
          <button onClick={connectWallet} style={{ background: '#10b981', color: '#000', padding: '16px 40px', fontSize: '20px', borderRadius: '9999px', margin: '0 auto', display: 'block' }}>
            Connect MetaMask (Polygon Amoy)
          </button>
        ) : (
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <p>Connected: <strong>{account.slice(0,6)}...{account.slice(-4)}</strong></p>
            <p>Balance: <strong>{parseFloat(balance).toFixed(4)} MATIC</strong></p>
          </div>
        )}

        {/* Markets */}
        <h3 style={{ textAlign: 'center', marginBottom: '30px' }}>Live Demo Markets</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '25px' }}>
          {["Will BTC reach $110,000 before June 2026?", "India win T20 World Cup 2026?", "Goa hotel occupancy >75% in May?"].map((q, i) => (
            <div key={i} style={{ background: '#1a1a1a', padding: '30px', borderRadius: '20px', border: '1px solid #333' }}>
              <h4 style={{ marginBottom: '20px' }}>{q}</h4>
              <button onClick={() => makePrediction(true)} disabled={loading} style={{ width: '100%', background: '#10b981', color: '#000', padding: '16px', borderRadius: '12px', marginBottom: '10px' }}>
                Yes
              </button>
              <button onClick={() => makePrediction(false)} disabled={loading} style={{ width: '100%', background: '#ef4444', color: '#fff', padding: '16px', borderRadius: '12px' }}>
                No
              </button>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '50px' }}>
          <button onClick={claimWinnings} style={{ background: '#eab308', color: '#000', padding: '16px 40px', fontSize: '18px', borderRadius: '9999px' }}>
            Claim Winnings
          </button>
        </div>
      </div>
    </div>
  );
}
